/**
 * 权限组件 - 根据权限控制组件显示
 */

import React, { ReactNode } from 'react';
import { hasPermission, hasRole } from '@/utils/auth';

interface PermissionProps {
  children: ReactNode;
  permission?: string | string[];
  role?: string | string[];
  requireAll?: boolean;
  fallback?: ReactNode;
}

/**
 * 权限组件
 * @param children 子组件
 * @param permission 需要的权限
 * @param role 需要的角色
 * @param requireAll 是否需要所有权限/角色（默认为false，表示有任意一个即可）
 * @param fallback 无权限时的替代组件
 */
const Permission: React.FC<PermissionProps> = ({
  children,
  permission,
  role,
  requireAll = false,
  fallback = null,
}) => {
  // 检查权限
  const checkPermission = (): boolean => {
    let hasPermissionAccess = true;
    let hasRoleAccess = true;

    // 检查权限
    if (permission) {
      const mode = requireAll ? 'all' : 'any';
      hasPermissionAccess = hasPermission(permission, mode);
    }

    // 检查角色
    if (role) {
      const mode = requireAll ? 'all' : 'any';
      hasRoleAccess = hasRole(role, mode);
    }

    return hasPermissionAccess && hasRoleAccess;
  };

  // 渲染结果
  if (checkPermission()) {
    return <>{children}</>;
  }

  return <>{fallback}</>;
};

export default Permission;